import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VetineoVisitTypeBundle} from "../vetineo-visit-type-bundle.model";

export class VetineoVisitTypeBundleDgSearchResults extends GenericDgSearchResults {
  public results: VetineoVisitTypeBundle[];

  constructor(total: number, results: VetineoVisitTypeBundle[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

